import { createSelector } from 'reselect';
import { RootState } from 'types/root-state';

export const getCookies = ({ cookies }: RootState) => cookies.cookies;

export const getCookiesString = createSelector(getCookies, cookies =>
	Object.entries(cookies)
		.map(cookie => cookie.join('='))
		.join('; ')
);

export const getRequestWhitelistCookiesString = createSelector(getCookies, cookies =>
	Object.entries(cookies)
		.filter(([key]) => key === 'testId')
		.map(cookie => cookie.join('='))
		.join('; ')
);

export const getCustomerID = createSelector(getCookies, cookies => cookies?.customerId ?? null);

export const getIsAuthorized = createSelector(
	getCookies,
	cookie => cookie?.['user-auth'] === 'true'
);
